import { render, staticRenderFns } from "./AlternativeNamesView.vue?vue&type=template&id=b9e71b04&scoped=true"
import script from "./AlternativeNamesView.vue?vue&type=script&lang=js"
export * from "./AlternativeNamesView.vue?vue&type=script&lang=js"
import style0 from "./AlternativeNamesView.vue?vue&type=style&index=0&id=b9e71b04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9e71b04",
  null
  
)

export default component.exports